<template>
    <pendo-button-group class="uploaded-file">
        <pendo-button
            :class="`file-info__${fileType}`"
            class="file-info-button"
            theme="app"
            :label="fileName"
            :disabled="true"
            :prefix-icon="fileIcon"
            type="tertiary" />
        <pendo-button
            v-if="removable"
            class="file-remove-button"
            theme="app"
            type="tertiary"
            icon="x"
            @click="handleRemove" />
    </pendo-button-group>
</template>

<script>
import { PendoButton, PendoButtonGroup } from '@pendo/components';

export default {
    name: 'AskPendoFileContext',
    components: {
        PendoButton,
        PendoButtonGroup,
    },
    props: {
        fileName: {
            type: String,
            required: true,
        },
        fileIcon: {
            type: String,
            default: 'file',
        },
        removable: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['remove-file'],
    methods: {
        handleRemove () {
            this.$emit('remove-file');
        },
    },
};
</script>

<style scoped lang="less">
.uploaded-file {
    border-radius: 8px;
    border: 1px solid var(--palette-gray-40);
    background: var(--brand-neutrals-brand-white);
    display: flex;
    height: 38px;
    justify-content: center;
    align-items: center;
    padding: 4px;
    gap: 4px;
    max-width: fit-content;
    margin: 16px 0 0 16px;
}

.file-info-button {
    cursor: default !Important;
    opacity: 1 !Important;
}
</style>
